/**
 * Created by Administrador on 06/05/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('passengerListCtrl', passengerListCtrl)
        .controller('passengerListByDepartureCtrl', passengerListByDepartureCtrl);

    passengerListCtrl.$inject = ['tabs','datePickerService', 'dateService', 'passengerListService','flightService','linkService','printService'];
    passengerListByDepartureCtrl.$inject = ['airports','tabs','datePickerService', 'dateService', 'passengerListService','flightService','linkService','printService'];

    function passengerListCtrl(tabs,datePickerService, dateService, passengerListService,flightService,linkService,printService) {
        var vm = this;
        vm.tabs = tabs;
        vm.isReport = false;
        vm.reportClassAvailabilityHtml = '';
        vm.datePickerOpenStatus = {
            departureDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerDepartureDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            },
            closed: function(args) {
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.filterPassengerList = {
            departureDate : new Date(),
            type: {"1": false, "2": false, "3": false},
            types: [
                {id: 1, name: "air.passengerList.filter.reserve"},
                {id: 2, name: "air.passengerList.filter.sold"},
                {id: 3, name: "air.passengerList.filter.checkIn"},
                {id: 4, name: "air.passengerList.filter.lowPnr"}
            ],
            typeValues: ["RESERVE", "SOLD", "CHECK_IN", "LOW_PNR"],
            detail: true
        }

        vm.eventFlights = function(){
            vm.report = undefined;
            if(vm.filterPassengerList.departureDate != undefined){
                vm.flights= [];
                flightService.getFlightsFromDate(vm.filterPassengerList.departureDate.getTime())
                    .then(function (response) {
                      var auxFlights = (response.data._embedded) ? response.data._embedded.flights : [];
                        angular.forEach(auxFlights, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials
                            });
                        });
                    });
            }
        }

        vm.eventFlights();

        vm.generate = function (isValid) {
            if(isValid) {
                vm.status = '';

                Object.keys(vm.filterPassengerList.type).forEach(function(key) {
                    if (vm.filterPassengerList.type[key] === true) {
                        vm.status = vm.status + 'status=' + vm.filterPassengerList.typeValues[parseInt(key) - 1] + '&';
                    }
                });

                passengerListService.getGeneralReportByFlight(vm.status,vm.filterPassengerList.flight.flightId,vm.filterPassengerList.detail)
                    .then(function (response) {
                    vm.reportClassAvailabilityHtml = response.data;
                    vm.isReport = true;
                });
                /*if(type=='flight'){
                    classAvailabilityService.getClassAvailabilityByFlight(fromDate, fromDate).then(function (response) {
                        vm.isReport = true;
                        vm.reportClassAvailabilityHtml = response.data;
                    });
                }else{
                    classAvailabilityService.getClassAvailabilityByConnection(fromDate, fromDate).then(function (response) {
                        vm.isReport = true;
                        vm.reportClassAvailabilityHtml = response.data;
                    });
                }*/
            }
        }

        vm.generatePdfHtml = function () {
            printService.printPdfHtml("reportClassAvailabilityHtml");
        }

        vm.generatePdf = function () {
            passengerListService.getGeneralReportByFlightPdf(vm.status,vm.filterPassengerList.flight.flightId,vm.filterPassengerList.detail).then(function (response) {
                if(response !== undefined){
                    var filePdf = new Blob([response.data], { type: 'application/pdf'});
                    var nameFile = 'arching-' + (new Date()).getTime() + '.pdf';
                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(filePdf, nameFile);
                    }else{
                        var fileURL = URL.createObjectURL(filePdf);
                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';
                        a.download = nameFile;
                        document.body.appendChild(a);
                        a.click();
                    }
                }

            });
        }
    }

    function passengerListByDepartureCtrl(airports,tabs,datePickerService, dateService, passengerListService,flightService,linkService,printService) {
        var vm = this;
        vm.tabs = tabs;
        vm.airports = airports;
        vm.isReport = false;
        vm.reportClassAvailabilityHtml = '';
        vm.datePickerOpenStatus = {
            departureDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerDepartureDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            },
            closed: function(args) {
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.filterPassengerList = {
            departureDate : new Date(),
            type: {"1": false, "2": false, "3": false},
            types: [
                {id: 1, name: "air.passengerList.filter.reserve"},
                {id: 2, name: "air.passengerList.filter.sold"},
                {id: 3, name: "air.passengerList.filter.checkIn"},
                {id: 4, name: "air.passengerList.filter.lowPnr"}
            ],
            typeValues: ["RESERVE", "SOLD", "CHECK_IN", "LOW_PNR"],
            detail: true
        }

        vm.eventChangeOrigin = function(){
            vm.reportClassAvailabilityHtml = undefined;
            if(vm.filterPassengerList.departureDate != undefined && vm.filterPassengerList.originAirport != undefined){
                vm.flights= [];
                flightService.getFlightByDepartureDateAndOrigin(vm.filterPassengerList.departureDate.getTime(),linkService.getLinkId(vm.filterPassengerList.originAirport._links.self.href))
                    .then(function (response) {
                        angular.forEach(response, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                departureFlightId: linkService.getLinkId(flight._embedded.departureflights[0]._links.self.href),
                                departureFlightOrder: flight._embedded.departureflights[0].order,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials
                            });
                        });
                    });
            }
        }

        /*vm.eventFlights = function(){
            vm.report = undefined;
            if(vm.filterPassengerList.departureDate != undefined){
                vm.flights= [];
                flightService.getFlightsFromDate(vm.filterPassengerList.departureDate.getTime())
                    .then(function (response) {
                        angular.forEach(response.data._embedded.flights, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                departureFlightId: linkService.getLinkId(flight._embedded.departureflights[0]._links.self.href),
                                route: flight._embedded.route.initials
                            });
                        });
                    });
            }
        }*/

        vm.generate = function (isValid) {
            if(isValid) {
                vm.status = '';

                Object.keys(vm.filterPassengerList.type).forEach(function(key) {
                    if (vm.filterPassengerList.type[key] === true) {
                        vm.status = vm.status + 'status=' + vm.filterPassengerList.typeValues[parseInt(key) - 1] + '&';
                    }
                });

                passengerListService.getGeneralReportByDeparture(vm.status,vm.filterPassengerList.flight.departureFlightId,vm.filterPassengerList.detail)
                    .then(function (response) {
                        vm.reportClassAvailabilityHtml = response.data;
                        vm.isReport = true;
                    });
            }
        }

        vm.generatePdfHtml = function () {
            printService.printPdfHtml("reportClassAvailabilityHtml");
        }

        vm.generatePdf = function () {
            passengerListService.getGeneralReportByFlightPdf(vm.status,vm.filterPassengerList.flight.departureFlightId,vm.filterPassengerList.detail).then(function (response) {
                if(response !== undefined){
                    var filePdf = new Blob([response.data], { type: 'application/pdf'});
                    var nameFile = 'arching-' + (new Date()).getTime() + '.pdf';
                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(filePdf, nameFile);
                    }else{
                        var fileURL = URL.createObjectURL(filePdf);
                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';
                        a.download = nameFile;
                        document.body.appendChild(a);
                        a.click();
                    }
                }

            });
        }
    }
})();
